import { graphql } from "@/gql";
import { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";

export type EmailEventsQueryVariables = VariablesOf<typeof emailEventListQuery>;
export type EmailEventItem = ResultOf<
  typeof emailEventListQuery
>["emailEvents"]["data"][number];

export const emailEventListQuery = graphql(`
  query EmailEvents(
    $object_type: ModelType!
    $object_id: ID!
    $orderBy: [QueryEmailEventsOrderByOrderByClause!]
  ) {
    emailEvents(
      object_type: $object_type
      object_id: $object_id
      orderBy: $orderBy
      first: 100
    ) {
      data {
        id
        type
        message_id
        recipient
        status
        failure_reason
        failure_code
        created_at
        updated_at
      }
    }
  }
`);
